<template>
    <v-layout column class="white" pa-2 style="width: 600px; height: 350px; border: solid 1px grey; border-radius: 4px; z-index: 1000">
    <scroll-area>
      <template slot="body">
        <v-layout v-if="showDatePickers" shrink justify-start align-center pl-3 pt-3>
          <v-flex xs6>
            <v-layout shrink justify-start align-end>
              <v-flex xs9>
                <date-picker
                  :value="filter.date.startRT"
                  :label="$t('date start')"
                  @dateChange="(payload) => dateMethod('startRT', payload)"
                />
              </v-flex>

              <v-flex xs3>
                <time-selector
                  v-if="filter.date.startRT"
                  :value="getItems.date.startRT.time"
                  @change="(payload) => timeMethod('startRT', payload)"
                />
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs6>
            <v-layout shrink justify-start align-end>
              <v-flex xs9>
                <date-picker
                  :value="filter.date.endRT"
                  :label="$t('date end')"
                  @dateChange="(payload) => dateMethod('endRT', payload)"
                />
              </v-flex>

              <v-flex xs3>
                <time-selector
                  v-if="filter.date.endRT"
                  :value="getItems.date.endRT.time"
                  @change="(payload) => timeMethod('endRT', payload)"
                />
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout column v-for="field in getColumns" :key="field.value + '_column'" justify-start align-baseline px-2 pb-2>
            <v-select :data-testid="$options.name + 'v-select' + field.value"
              v-if="field.filter"
              v-model="filter[field.value]"
              light
              :menu-props="{ 
                maxHeight: '400',
                openOnClick: true,
                closeOnContentClick: true
              }"
              :items="getItems[field.dataKey]"
              outline
              :placeholder="$t(field.title)"
              hide-details
              class="white"
              color="primary"
              background-color="backgrey"
              fill-width
              :style="'width: -webkit-fill-available;'"
              multiple
              clearable
            >
              <template v-slot:item="{ item, index }">
                  <span>{{ $t(String(item)) }}</span>
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" :key="index">{{ $t(String(item))}}</span>
                <span v-else :key="index">{{ ', ' + $t(String(item)) }}</span>
              </template>
            </v-select>
        </v-layout>

        <v-layout justify-space-between align-center>
          <v-layout shrink justify-start align-center>
            <v-flex shrink px-2>
              <v-btn :data-testid="$options.name + 'v-btn' + 'submitFilter'" color="accent" @click="submitFilter()" block  depressed small dark >
                <v-layout  justify-start align-center>
                  <span>{{$t('apply')}} {{$t('filters')}}</span>
                </v-layout>
              </v-btn>
            </v-flex>

            <v-flex shrink px-2>
              <v-btn :data-testid="$options.name + 'v-btn' + 'reset'" color="grey" @click="reset()" block outline depressed small light>
                <v-layout  justify-start align-center>
                  <span class="blacktext--text" >{{$t('reset')}} {{$t('filters')}}</span>
                </v-layout>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout shrink justify-end align-center>
            <v-flex shrink px-2>
              <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" color="grey" @click="() => {$emit('close')}" block outline depressed small light>
                <span class="blacktext--text" >{{$t('close')}} </span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </template>
    </scroll-area>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'
import timeSelector from '@/nms/components/controls/time-selector.vue'

// Типы для фильтров
interface DateItem {
  date: string
  time: string
  value: string | null
}

interface FilterDate {
  startRT: DateItem
  endRT: DateItem
}

interface FilterData {
  date: {
    startRT: string
    endRT: string
  }
  [key: string]: any
}

interface ItemsData {
  date: FilterDate
  [key: string]: any
}

interface TableData {
  [key: string]: any
}

interface ColumnItem {
  value?: string
  dataKey?: string
  filter?: boolean
  [key: string]: any
}

export default Vue.extend({
  name: 'FILTER_BAR',

  components: {
    scrollArea,
    datePicker,
    timeSelector,
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: Number,
      default: () => 1500
    },
    data: {
      type: Array as () => any[],
      default: () => []
    },
    table: {
      type: Object as () => TableData,
      default: () => ({})
    },
    columns: {
      type: Array as () => ColumnItem[],
      default: () => []
    },
  },

  data(): {
    barOpen: boolean
    barSize: number
    items: ItemsData
    showDatePickers: boolean
    filterPath: string
    filter: FilterData
  } {
    return {
      barOpen: true,
      barSize: 300,
      items: {
        date: {
          startRT: {
            date: '',
            time: '',
            value: null,
          },
          endRT: {
            date: '',
            time: '',
            value: null,
          },
        },
      },
      showDatePickers: true,
      filterPath: 'showFullPath',
      filter: {
        date: {
          startRT: '',
          endRT: '',
        },
      },
    }
  },

  computed: {
    getSize(): number {
      return this.size
    },

    getColumns(): ColumnItem[] {
      return this.columns
    },

    getItems(): ItemsData {
      return this.items
    },
  },

  watch: {
    filterPath: {
      handler(newVal: string): void {
        this.$emit('filterPath', this.filterPath)
      },
      deep: true
    },
    
    data: {
      handler(newVal: any[]): void {
        if (newVal) {
          this.setup()
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
  },

  methods: {
    async setup(): Promise<void> {
      await this.loadItems()
    },

    async loadItems(): Promise<void> {
      const data$ = this.$merge({}, this.data)
      
      for (const column of this.getColumns) {
        if (column.filter) {
          const group = new Set()
          for (const obj of data$) {
            const val = this.getColumnValue(obj, column.value || '')
            if (val) {
              group.add(this.getColumnValue(obj, column.value || ''))
            }
          }
          this.$set(this.items, column.dataKey || '', Array.from(group))
        }
      }
    },

    dateMethod(mode: string, val: string): void {
      this.$set(this.filter.date, mode, new Date(val))
    },

    timeMethod(mode: string, val: string): void {
      const hours = val.slice(0, 2)
      const minutes = val.slice(-2)
      const date$ = this.filter.date[mode as keyof typeof this.filter.date]
      
      if (date$ && typeof date$ === 'object' && date$ instanceof Date) {
        date$.setHours(parseInt(hours))
        date$.setMinutes(parseInt(minutes))
      }
    },

    closeOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
      }
    },

    close(): void {
      this.$emit('close')
    },

    getColumnValue(obj: any, value: string): any {
      const val = value.split('.')
      let resp = ''
      
      if (val && val.length > 1) {
        let v = obj
        val.forEach((key: string) => {
          v = v[key]
        })
        resp = v
      } else {
        resp = obj[value]
      }
      return resp
    },

    async reset(): Promise<void> {
      this.$set(this.items, 'date', {
        startRT: {
          date: '',
          time: '',
          value: null,
        },
        endRT: {
          date: '',
          time: '',
          value: null,
        },
      })

      this.showDatePickers = false
      this.$nextTick(() => {
        this.showDatePickers = true
      })
      
      this.filterPath = 'showFullPath'
      this.filter = {
        date: {
          startRT: '',
          endRT: '',
        },
      }
      
      await this.$store.dispatch('statusCounterStatusFilter', {
        parentCls: null,
        parentName: null,
        'ss.state': null,
        template: null,
        'info.device_type': null,
        'info.manufacturer': null,
      })
      
      this.setup()
      this.$emit('filter', this.filter)
      this.$emit('close')
    },

    submitFilter(): void {
      console.log('FILTERS', 'submitFilter', this.filter)
      const filter$ = { ...this.filter }
      this.$emit('filter', filter$)
      this.$emit('close')
    },
  },
})
</script>

<style lang="css" scoped>
</style>
